import {
  useContext,
} from 'react';

import styled from "styled-components";

import { ThemeContext } from '@dstantwo/ullr-react-components';

import CONSTANTS from '../../constants';

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px'
}

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`
};

export const UllrCard = styled.div`
  display: flex;
  flex: ${props => props.flex !== undefined ? props.flex : '0 0 auto'};
  flex-direction: column;
  max-width: ${props => props.maxWidth || 'auto'};
  border-radius: 12px;
  margin: 12px;
  padding: 12px 16px;
  background: ${() => useContext(ThemeContext).COLORS.WHITE};
  box-shadow: 0 4px 12px 0 rgba(0,0,0,0.1);

  @media ${CONSTANTS.DEVICE_SIZE.tablet} { 
    margin: 12px 4px;
  }
`;

export const UllrLoginCard = styled(UllrCard)`
  max-width: 600px;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 56px 16px 56px;
  margin: 0px;
  margin-bottom: 32px;

  @media ${CONSTANTS.DEVICE_SIZE.tablet} { 
    padding-top: 32px;
    padding-bottom: 32px;
  }
`;
